export default __webpack_public_path__ + "static/media/icon-infusion-without-additive.666bee7f.svg";